import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { DetailsErrorBoundary } from '../details-error/details-error';
import { DetailsSeriesView } from '../details-series/details-series-view';
import { DetailsSourcesList } from '../details-sources/details-sources-list';
import { DetailsSpacing } from '../details-spacing/details-spacing';
import { useAvailableContexts } from '../use-available-contexts';
import css from './details-controller.module.scss';

interface DetailsControllerProps {
  asset: Asset;
}

export function DetailsController({ asset }: DetailsControllerProps) {
  const { t } = useTranslation('details');
  const availableContexts = useAvailableContexts(asset);

  return (
    <Fragment>
      {availableContexts.length > 1 ? (
        <DetailsSpacing>
          <section>
            <h2 className={css.title}>{t('provider-title-label')}</h2>
            <DetailsErrorBoundary label="sources">
              <DetailsSourcesList asset={asset} availableContexts={availableContexts} />
            </DetailsErrorBoundary>
          </section>
        </DetailsSpacing>
      ) : null}

      {asset.type === 'series' && (
        <DetailsSpacing>
          <section className={css.series}>
            <DetailsErrorBoundary label="series">
              <DetailsSeriesView asset={asset} />
            </DetailsErrorBoundary>
          </section>
        </DetailsSpacing>
      )}
    </Fragment>
  );
}
